<mat-toolbar color="primary" class="custom-primary customer">
    <div class="center-content">
        <span>
            <img class="logo" src="assets/images/logo.png" alt="">
        </span>
    </div>
</mat-toolbar>
<div class="container">
    <router-outlet></router-outlet>
    <!--<app-version-link></app-version-link>-->
</div>